module.exports = __webpack_public_path__ + "76688bc8c39d1c6a33ea2a34e0a8db95.png";